module.exports = require("@ng-toolkit/universal");